/**
 * 主办方相关接口
 */

import IS_DEV from '@utils/env/is-dev';
import { get, post } from 'src/lib/http';
import { HttpPrefix } from 'src/lib/wemeet-http-moudle';
import { CountData } from './activity';
import DashboardOrgGetUserHostOrgList, {
  OrgList,
} from '@quickService/DashboardOrgGetUserHostOrgList';
import DashboardOrgSelectHostOrg from '@quickService/DashboardOrgSelectHostOrg';
export type HostList = OrgList;
export interface IsHostRes {
  code: number;
  msg: string;
  nonce: string;
  data: {
    is_host: boolean;
  };
}

export interface IndustriesData {
  code: string;
  name: string;
}

export interface IndustriesListRes {
  code: number;
  msg: string;
  nonce: string;
  data: {
    industries: Array<IndustriesData>;
  };
}

export interface CreateAccountRes {
  code: number;
  msg: string;
  nonce: string;
  data: {
    host_id: number;
  };
}

export interface HostDetailData {
  host_name: string;
  host_id: string;
  avatar_url: string;
  industry_name: string;
  label: Array<string>;
  industry_code: string;
  // industry_codes: string[];
  fans_info: { fans_count: number };
  activity_info: CountData;
  introduction: string;
  bg_web_url: string;
  bg_mobile_url: string;
  bg_web_color?: string;
  bg_mobile_color?: string;
  ip_attribution?: string;
  theme?: 'light' | 'dark' | undefined;
  role_id?: string | number;
  industry_infos: {
    industry_code: string;
    industry_name: string;
  }[];
}

export interface HostDetailRes {
  code: number;
  msg: string;
  nonce: string;
  data: {
    host_detail: HostDetailData;
    is_subscribed?: boolean;
    is_owned?: boolean;
    participant_count?: number;
  };
}

export interface UpdateHostDetailPostData {
  host_name: string;
  avatar_cos_key: string;
  // industry_code: string,
  label: Array<string>;
  introduction: string;
  host_id: number | string;
  industry_codes: string[];
}

// 查询主办方行业列表
let prevIndustryReq: Promise<IndustriesData[]>;
export const getIndustriesList = (fromCache = false) => {
  if (fromCache && typeof prevIndustryReq !== 'undefined') return prevIndustryReq;
  const path = '/v2/activities/public/host/industries';
  return (prevIndustryReq = new Promise<Array<IndustriesData>>((resolve, reject) => {
    get<IndustriesListRes>(HttpPrefix.WEMEET_TAPI, path, {}).then(
      (res) => {
        const { code, data, msg } = res;
        if (code === 0) {
          const { industries } = data;
          resolve(industries);
        } else {
          reject(msg);
        }
      },
      (e) => {
        reject(e);
      },
    );
  }));
};

// 创建主办方账号
export const createAccount = (data: any) => {
  const path = '/v2/activities/host/create-account';
  return new Promise<string>((resolve, reject) => {
    post(HttpPrefix.WEMEET_TAPI, path, data).then(
      (res) => {
        const { code, data = {}, msg } = res;
        if (code === 0) {
          resolve(data.host_id);
        } else {
          reject(msg);
        }
      },
      (e) => {
        reject(e);
      },
    );
  });
};

/** 获取自己的主页资料 */
export const getHostDetail = (hostId?: string) => {
  const path = '/v2/activities/host/detail';
  return Promise.all([
    getIndustriesList(true).catch(() => []),
    get<HostDetailRes>(HttpPrefix.WEMEET_TAPI, path, {
      host_id: hostId,
    }).then((res) => {
      const { code, msg, data } = res;
      if (code === 0) {
        const { host_detail: detailData } = data;
        // 将当前主办方账号存到全局变量, 仅用于调试
        // @ts-ignore
        window.__host_id = detailData.host_id;
        return detailData;
      }
      return Promise.reject({
        msg,
        code,
      });
    }),
  ]).then(([industries, detail]) => ({
    ...detail,
    industry_name: industries.find((industry) => industry.code === detail.industry_code)
      ?.name as string,
  }));
};

/** 根据ID获取主办方账号 */
export const getHostDetailById = (id: number | string) =>
  get<HostDetailRes>(HttpPrefix.WEMEET_TAPI, '/v2/activities/public/host/detail', {
    host_id: id,
  }).then((res) => {
    if (res.code !== 0) return Promise.reject(res);
    return res.data;
  });

// 更新主办方详情数据
export const updateHostDetail = (postData: UpdateHostDetailPostData) => {
  const path = '/v2/activities/host/update-detail';
  return new Promise((resolve, reject) => {
    post(HttpPrefix.WEMEET_TAPI, path, postData).then(
      (res) => {
        const { code, msg } = res;
        if (code === 0) {
          resolve(code);
        } else {
          reject(msg);
        }
      },
      (e) => {
        reject(e);
      },
    );
  });
};

if (typeof window !== 'undefined' && IS_DEV) {
  // @ts-ignore
  window.__delete_my_account = () =>
    post(
      HttpPrefix.WEMEET_TAPI,
      '/v2/activities/host/del-account?c_instance_id=5',
      // @ts-ignore
      { host_id: window.__host_id },
    );
}

// 根据当前登录态获取用户主办方列表
export const getUserHostList = async () => {
  try {
    const { data, code } = await DashboardOrgGetUserHostOrgList({
      avatar_image_type: 'avatar_middle',
    });
    if (code === 0) return data;
    return {
      org_list: [],
      selected_host_id: '',
    };
  } catch (error) {
    console.log(error);
    // 上报日志需要脱敏
    // const err = typeof error === 'string' ? error : JSON.stringify(error);
    // window?.nextAegis?.error(`[login-util] 【getUserHostList】UserHostList：${err}`);
  }
};

// 根据当前登录态设置用户主办方常用ID
export const setUserHostId = async (hostId: string) => {
  try {
    const { code } = await DashboardOrgSelectHostOrg({
      host_id: hostId,
    });
    if (code === 0) return hostId;
    return {
      hostId: '-1',
    };
  } catch (error) {
    console.log(error);
    return {
      hostId: '',
    };
  }
};
